import React, { useEffect, useState } from "react";
import "./tournament.css";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import CustomSvg from "../svgs/CustomSvg";
import { useGames } from "../../utils/hooks";
import { formatDateTimeDash } from "../../utils";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../apiRequests/requestApi";
import { toast } from "react-toastify";
import Coin from "../../assets/images/coin.svg";

function AllTournaments() {
  const [openGames, setOpenGames] = useState(false);
  const [tournamentvs, setTournamentvs] = useState(true);
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");
  const [activeTab, setActiveTab] = useState("ongoing");
  const [showModal, setShowModal] = useState(false);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { getTournaments, tournaments } = useGames();
  const [participatingTournaments, setParticipatingTournaments] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) setBlocksOpen("both");
    else if (!isLeftBlockOpen && !isRightBlockOpen) setBlocksOpen("none");
    else setBlocksOpen("one");
  }, [isLeftBlockOpen, isRightBlockOpen]);

  useEffect(() => {
    getTournaments(currentPage);
  }, [currentPage]);

  const handleModalOpen = (tournament) => {
    setSelectedTournament(tournament);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setSelectedTournament(null);
    setShowModal(false);
  };

  const categorizeTournaments = () => {
    const now = new Date();
    return {
      ongoing: tournaments.filter(
        (t) => new Date(t.startDate) <= now && new Date(t.endDate) >= now
      ),
      upcoming: tournaments.filter((t) => new Date(t.startDate) > now),
      ended: tournaments.filter((t) => new Date(t.endDate) < now),
    };
  };

  const joinTournament = async (tournament) => {
    if (tournament?.hasStarted === false && tournament?.hasEnded === false) {
      try {
        const response = await postRequest({
          url: "/join-tournament",
          data: { joiningCode: tournament.joiningCode },
        });

        if (response?.success) {
          toast.success(response?.message || "Successfully joined!");
        } else {
          toast.error(response?.message || "Could not join tournament.");
        }
      } catch (error) {
        toast.error(error?.message || "An error occurred.");
      }
    } else {
      toast.error("This tournament is not joinable.");
    }
  };
  useEffect(() => {
    const fetchParticipatingTournaments = async () => {
      setLoading(true);
      try {
        const response = await getRequest("/participating-tournaments");
        if (response?.success) {
          setParticipatingTournaments(response.data || []);
        }
      } catch (error) {
        toast.error(
          error?.message || "Failed to fetch participating tournaments."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchParticipatingTournaments();
  }, []);

  const isUserParticipating = (code) => {
    return participatingTournaments.some(
      (tournament) => tournament.joiningCode === code
    );
  };

  const { ongoing, upcoming, ended } = categorizeTournaments();
  const displayedTournaments =
    activeTab === "ongoing"
      ? ongoing
      : activeTab === "upcoming"
      ? upcoming
      : ended;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#130828] flex items-center justify-center text-white">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-white border-t-pink-500 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-semibold">Loading tournaments...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-6 bg-[#130828] px-2 text-white">
      <div className="relative flex items-center justify-center py-5">
        <div className="absolute -left-1">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold text-center">
          Tournaments{" "}
          <span className="bg-gradient-to-r from-[#C6BCFF] to-[#ec4899] bg-clip-text text-transparent">
            Arena
          </span>
        </h2>
      </div>

      <div className="m-6 px-2 lg:px-8">
        {tournamentvs && (
          <div className="w-full">
            <div className="flex flex-col lg:flex-row justify-between gap-4">
              {/* Left Block */}
              <div
                className={`${
                  isLeftBlockOpen ? "w-1/6" : "w-[4%]"
                } hidden lg:block`}
              >
                <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
              </div>

              {/* Center Content */}
              <div
                className={`${
                  blocksOpen === "both"
                    ? "lg:w-2/3"
                    : blocksOpen === "one"
                    ? "lg:w-3/4"
                    : "lg:w-5/6"
                } w-full`}
              >
                <div className="flex flex-col flx-wrap">
                  <div className="flex mb-6 items-center justify-center text-center flex-wrap gap-2">
                    {["ongoing", "upcoming", "ended"].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-1 rounded-full font-medium transition-colors duration-200 ${
                          activeTab === tab
                            ? "bg-pink-500 text-white"
                            : "bg-white text-gray-800 text-xs hover:bg-gray-200"
                        }`}
                      >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                      </button>
                    ))}
                  </div>

                  {displayedTournaments.length === 0 ? (
                    <div className="text-lg font-semibold text-center font-quantico">
                      No tournaments found
                    </div>
                  ) : (
                    displayedTournaments.map((tournament, i) => {
                      const {
                        name,
                        gateFee,
                        registrationDeadline,
                        noOfWinners,
                        startDate,
                        prizes,
                      } = tournament;

                      const isJoinable = activeTab === "upcoming";
                      const totalPrizeMoney =
                        prizes?.reduce((sum, value) => sum + value, 0) || 0;

                      return (
                        <div
                          key={i}
                          className="border-b border-white/20 pb-6 mb-6 flex flex-col md:flex-row justify-between md:items-center gap-4"
                        >
                          <div className="md:w-2/3">
                            <h4 className="text-xl font-semibold mb-2 capitalize font-quantico">
                              {name}
                            </h4>
                            <p className="text-sm font-quantico mb-1">
                              Cash Pool:{" "}
                              <span className="text-pink-400">
                                <img
                                  src={Coin}
                                  alt="coin"
                                  className="w-5 h-5 inline-block align-middle mr-1"
                                />
                                {(totalPrizeMoney / 100).toLocaleString()}
                              </span>
                            </p>
                            <p className="text-sm font-quantico mb-1">
                              Gate fee:{" "}
                              <span className="text-pink-400">
                                <img
                                  src={Coin}
                                  alt="coin"
                                  className="w-5 h-5 inline-block align-middle mr-1"
                                />
                                {gateFee / 100}
                              </span>
                            </p>
                            <p className="text-sm font-quantico mb-1">
                              Registration Deadline:{" "}
                              <span className="text-pink-400">
                                {formatDateTimeDash(registrationDeadline)}
                              </span>
                            </p>
                            <p className="text-sm font-quantico mb-1">
                              Start:{" "}
                              <span className="text-pink-400">
                                {formatDateTimeDash(startDate)}
                              </span>
                            </p>
                            <p className="text-sm font-quantico">
                              There can only be{" "}
                              <span className="text-pink-400">
                                {noOfWinners}
                              </span>{" "}
                              winner(s)
                            </p>
                          </div>

                          <div className="flex gap-3 md:mt-0">
                            <button
                              onClick={() => handleModalOpen(tournament)}
                              className="border border-white text-white rounded-lg py-2 px-4 text-xs font-medium hover:bg-white hover:text-black transition"
                            >
                              View Details
                            </button>
                            <button
                              onClick={() => {
                                if (activeTab === "ongoing") {
                                  if (
                                    isUserParticipating(
                                      tournament.joiningCode
                                    ) &&
                                    tournament?.gameInfo?._id &&
                                    tournament?.gameInfo?.name
                                  ) {
                                    navigate(
                                      `/tournament/lobby/${tournament.joiningCode}/${tournament._id}/${tournament.gameInfo._id}/${tournament.gameInfo.name}`
                                    );
                                  } else {
                                    toast.error(
                                      "Invalid tournament or game info."
                                    );
                                  }
                                } else if (activeTab === "upcoming") {
                                  joinTournament(tournament);
                                } else if (activeTab === "ended") {
                                  navigate(
                                    `/celebrity/${tournament._id}/leaderboard`
                                  );
                                }
                              }}
                              className={`border rounded-lg py-2 px-4 text-xs font-medium flex items-center gap-2 transition-all ${
                                activeTab === "ended"
                                  ? "border-blue-500 text-blue-300 hover:text-white hover:bg-blue-600"
                                  : "border-pink-500 text-white hover:bg-pink-500 hover:text-black"
                              }`}
                            >
                              {activeTab === "ongoing"
                                ? "Enter Lobby"
                                : activeTab === "upcoming"
                                ? "Join Now"
                                : "View Leaderboard"}{" "}
                              <CustomSvg name="arrow-right" />
                            </button>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
                <div className="flex justify-center gap-4 mt-6">
                  <button
                    disabled={currentPage === 1}
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    className="px-4 py-2 rounded bg-white text-black disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span className="text-white font-semibold">
                    {currentPage}
                  </span>
                  <button
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-4 py-2 rounded bg-white text-black"
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                className={`${
                  isRightBlockOpen ? "w-1/6" : "w-[4%]"
                } hidden lg:flex justify-end`}
              >
                <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && selectedTournament && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
          role="dialog"
          aria-modal="true"
        >
          <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full relative animate-fade-in">
            <button
              onClick={handleModalClose}
              className="absolute top-2 right-3 text-white text-lg"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold text-pink-500 mb-4 font-quantico">
              {selectedTournament.name}
            </h2>
            <p>
              Gate Fee:{" "}
              <img
                src={Coin}
                alt="coin"
                className="w-5 h-5 inline-block align-middle mr-1"
              />
              {selectedTournament.gateFee / 100}
            </p>
            <p>
              Deadline:{" "}
              {formatDateTimeDash(selectedTournament.registrationDeadline)}
            </p>
            <p>Start: {formatDateTimeDash(selectedTournament.startDate)}</p>
            <p>End: {formatDateTimeDash(selectedTournament.endDate)}</p>
            <p>Winners: {selectedTournament.noOfWinners}</p>
            <p className="mt-4 text-sm text-white/80">
              This tournament is hosted by{" "}
              <span className=" font-bold">
                {selectedTournament?.creatorInfo?.username}
              </span>{" "}
              follow him on{" "}
              <span className=" font-bold">
                {selectedTournament?.creatorInfo?.socialMediaPlatform}
              </span>{" "}
              at{" "}
              <span className=" font-bold">
                {selectedTournament?.creatorInfo?.socialMediaHandle}.
              </span>{" "}
              it is an {activeTab.toUpperCase()} tournament. Make sure you’re
              eligible before joining.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default AllTournaments;
